import React from 'react';
import PropTypes from 'prop-types';
import Iframe from 'components/utilities/Iframe';
import { enturApiGet } from 'server/api';
import { fakeColorOpacity } from 'utils/color';
import * as styles from './EnturWidget.scss';

class EnturWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { geoLocation } = this.props;
    enturApiGet(
      `https://api.entur.io/geocoder/v1/reverse?point.lat=${geoLocation.latitude}&point.lon=${geoLocation.longitude}&boundary.circle.radius=1&size=10&layers=address`,
    ).then(res => {
      if (res && res.features.length > 0) {
        const { features } = res;
        const { address, name } = this.props;

        const featuresByName = features.filter(f =>
          f.properties.name.toLowerCase().includes(name.toLowerCase()),
        );

        const featuresByAddress = features.filter(
          f =>
            address.street.length &&
            f.properties.name
              .toLowerCase()
              .includes(address.street.toLowerCase()),
        );

        let feature = featuresByName.length && featuresByName[0];
        if (!feature) feature = featuresByAddress && featuresByAddress[0];

        if (feature)
          this.setState({
            id: feature.properties.source_id,
            coordinates: feature.geometry.coordinates,
          });
      }
    });
  }

  render() {
    const { address, color, culture, geoLocation } = this.props;
    const { id, coordinates } = this.state;
    const style = {
      width: '100%',
      height: '100%',
      minHeight: '275px',
      minWidth: '340px',
      display: 'block',
    };
    const lang = culture === 'no' ? 'nob' : 'eng';
    const longitude = coordinates ? coordinates[0] : geoLocation.longitude;
    const latitude = coordinates ? coordinates[1] : geoLocation.latitude;
    const src = `https://widget.entur.no/compact?target=_target&defaultLang=${lang}&suggestionLimit=1&toName=${encodeURIComponent(
      address.street.split(',')[0].split('-')[0],
    )}&toPlace=${encodeURIComponent(id) ||
      0}&toCoords=${latitude}%2C${longitude}`;
    const colorParams = color
      ? `&bgrC=${encodeURIComponent(
          color,
        )}&btnGrpMngtActBgrCol=%23fff&fcBrdrBrndC=%23fff&fcTxtC=%23000&btnGrpMngtActBrdrCol=%23fff&btnGrpMngtBrdrCol=%23fff&btnGrpMngtBgrCol=${encodeURIComponent(
          fakeColorOpacity(color, 0.7),
        )}&btnGrpMngtTxtCol=%23000&btnGrpMngtActTxtCol=%23000`
      : '';
    return id ? (
      <Iframe
        title="Entur-widget"
        frameBorder={0}
        style={style}
        src={src + colorParams}
      ></Iframe>
    ) : null;
  }
}
EnturWidget.displayName = 'EnturWidget';

EnturWidget.propTypes = {
  color: PropTypes.string,
  geoLocation: PropTypes.object,
  address: PropTypes.object,
  culture: PropTypes.string,
  name: PropTypes.string,
};
EnturWidget.defaultProps = {};

export default EnturWidget;
